import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import MultiProvider from "config/MultiProvider";
import "nprogress/nprogress.css";
import "pure-react-carousel/dist/react-carousel.es.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter } from "react-router-dom";
import "simplebar-react/dist/simplebar.min.css";
import App from "./App";

// Providers
import { EditProvider } from 'contexts/EditContext';
import AuthProvider from "contexts/AuthContext";
import MemberProvider from "contexts/MemberContext";
import PartnerProvider from "contexts/PartnerContext";
import ContentProvider from "contexts/ContentContext";
import MasterDataProvider from "contexts/MasterDataContext";
import PortalManagementProvider from "contexts/PortalManagement";
import UserManagementProvider from "contexts/UserManagement";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MultiProvider
        providers={[
          <AuthProvider />,
          <UserManagementProvider />,
          <ContentProvider />,
          <MasterDataProvider />,
          <PortalManagementProvider />,
          <EditProvider/>,
          <MemberProvider />,
          <PartnerProvider />,
        ]}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <App />
        </LocalizationProvider>
      </MultiProvider>
    </BrowserRouter>
  </React.StrictMode>
);
